import type { Session } from '@supabase/supabase-js';
import { create } from 'zustand';
import { supabase } from '../lib/supabase';

/**
 * Supabase Auth 세션의 동기 미러 — 라우터 가드/헤더 표시용.
 * 서버 데이터(프로필 등)는 TanStack Query가 담당한다 (CLAUDE.md 규칙 4).
 */
interface AuthState {
  session: Session | null;
  /** onAuthStateChange 첫 이벤트 수신 전 */
  initializing: boolean;
}

export const useAuthStore = create<AuthState>(() => ({
  session: null,
  initializing: true,
}));

let started = false;

/** 앱 시작 시 1회 호출 — 세션 복원 + 변경 구독 */
export function startAuthListener(): void {
  if (started) return;
  started = true;

  void supabase.auth.getSession().then(({ data }) => {
    useAuthStore.setState({ session: data.session, initializing: false });
  });

  supabase.auth.onAuthStateChange((_event, session) => {
    useAuthStore.setState({ session, initializing: false });
  });
}
